import { css, cx } from "@emotion/css"

import IconButton, { IconButtonProps } from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"

const styles = {
  root: css`
    top: 8px;
    right: 8px;
    position: absolute;
  `,
  icon: css`
    > span > svg {
      width: 24px;
      height: 24px;
    }
  `,
}

export type DialogCloseProps = {
  className?: string
  onClose: () => void
} & Omit<IconButtonProps, "onClick" | "className">

export function DialogClose(props: DialogCloseProps) {
  const { onClose, className, ...iconButtonProps } = props
  return (
    <div data-dialog-close-button className={cx(styles.root, className)}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        {...iconButtonProps}
        className={styles.icon}
      >
        <CloseIcon />
      </IconButton>
    </div>
  )
}
